import { useState } from 'react'
import { range } from '../../helpers/common'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import { ButtonSubmit } from './ButtonSubmit'
import { checkMaxYear, checkMinYear } from './helper'
import classes from './index.module.scss'

const pageSize = 16

const SelectYear = ({
  stateMonthYear,
  setStateMonthYear,
  disableSelectYear,
  minYear,
  maxYear,
}) => {
  const [years, setYears] = useState(
    range(stateMonthYear.year - 8, stateMonthYear.year + 7),
  )

  const nextYears = () => {
    const start = years[0] + pageSize
    const end = years[years.length - 1] + pageSize
    const isValidYears = checkMaxYear(start, maxYear)

    if (isValidYears) {
      setYears(range(start, end))
    }
  }

  const backYears = () => {
    const start = years[0] - pageSize
    const end = years[years.length - 1] - pageSize
    const isValidYears = checkMinYear(end, minYear)

    if (isValidYears) {
      setYears(range(start, end))
    }
  }

  return (
    <Element
      style={{ backgroundColor: '#FFFFFF' }}
      className={classes.calendarContainer}
    >
      <div
        className={`${classes.monthYearContainer} ${classes.pd0} ${classes.monthYearSingle}`}
      >
        <div
          className={`${classes.monthYear} justifyContentBetween ${classes.w100}`}
        >
          <Icon
            className="icon-arrow-left"
            style={{ fontSize: 10 }}
            onClick={backYears}
          />
          <Element
            className={classes.monthYearDisplay}
            style={{ fontSize: 14 }}
          >
            {years[0]}-{years[years.length - 1]}
          </Element>
          <Icon
            className="icon-arrow-right"
            style={{ fontSize: 10 }}
            onClick={nextYears}
          />
        </div>
      </div>
      <div className={classes.monthYearCalendarContainer}>
        {years.map((year) => {
          const active = stateMonthYear.year === year

          const isValidYear =
            checkMinYear(year, minYear) && checkMaxYear(year, maxYear)

          const classMonth = isValidYear
            ? `${classes.month} ${active ? classes.monthActive : ''}`
            : classes.monthDisable

          const chooseYear = isValidYear
            ? () => {
                setStateMonthYear({ ...stateMonthYear, year })
                disableSelectYear()
              }
            : undefined

          return (
            <div key={year} onClick={chooseYear} className={classMonth}>
              <span>{year}</span>
            </div>
          )
        })}
      </div>
      <div className={classes.buttonContainer}>
        <ButtonSubmit submit={disableSelectYear} />
      </div>
    </Element>
  )
}

export default SelectYear
